import React, { useState } from 'react';
import { OfficerLayout } from '../../components/layout/OfficerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { ChevronLeft, UploadCloud, Link as LinkIcon, CheckCircle2, AlertCircle, Image as ImageIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal } from '../../components/ui/Modal';
export function SubmitBuktiPostingPage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccessModalOpen(true);
    }, 1500);
  };
  return <OfficerLayout data-id="element-3769">
      <div className="pb-24" data-id="element-3770">
        {/* Header */}
        <div className="flex items-center gap-2 mb-6" data-id="element-3771">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="-ml-2" data-id="element-3772">
            <ChevronLeft className="h-6 w-6" data-id="element-3773" />
          </Button>
          <h1 className="text-lg font-bold text-gray-900" data-id="element-3774">Submit Bukti</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-3775">
          <Card data-id="element-3776">
            <CardContent className="p-6 space-y-4" data-id="element-3777">
              <div data-id="element-3778">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3779">
                  Platform <span className="text-red-500" data-id="element-3780">*</span>
                </label>
                <Select required value={selectedPlatform} onChange={e => setSelectedPlatform(e.target.value)} data-id="element-3781">
                  <option value="" data-id="element-3782">Pilih Platform</option>
                  <option value="instagram" data-id="element-3783">Instagram</option>
                  <option value="tiktok" data-id="element-3784">TikTok</option>
                  <option value="facebook" data-id="element-3785">Facebook</option>
                  <option value="youtube" data-id="element-3786">YouTube</option>
                  <option value="x" data-id="element-3787">X (Twitter)</option>
                </Select>
              </div>

              <div data-id="element-3788">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3789">
                  Link Postingan <span className="text-red-500" data-id="element-3790">*</span>
                </label>
                <div className="relative" data-id="element-3791">
                  <LinkIcon className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-3792" />
                  <Input placeholder="https://..." className="pl-9" required data-id="element-3793" />
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-3794">
                  Pastikan akun tidak di-private agar bisa divalidasi.
                </p>
              </div>

              <div data-id="element-3795">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3796">
                  Screenshot Bukti (Opsional)
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-3797">
                  <UploadCloud className="h-8 w-8 text-gray-400 mx-auto mb-2" data-id="element-3798" />
                  <p className="text-sm font-medium text-gray-900" data-id="element-3799">
                    Upload Screenshot
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-3800">JPG/PNG max 5MB</p>
                </div>
                <p className="text-xs text-yellow-600 mt-2 flex items-center gap-1" data-id="element-3801">
                  <AlertCircle className="h-3 w-3" data-id="element-3802" /> Wajib jika akun private
                </p>
              </div>
            </CardContent>
          </Card>

          <Button type="submit" className="w-full bg-primary-600 hover:bg-primary-700 text-white h-12 text-lg font-medium shadow-md" isLoading={isSubmitting} data-id="element-3803">
            Kirim Laporan
          </Button>
        </form>

        {/* Success Modal */}
        <Modal isOpen={isSuccessModalOpen} onClose={() => {
        setIsSuccessModalOpen(false);
        navigate('/officer/distribusi');
      }} title="" size="sm" className="text-center" data-id="element-3804">
          <div className="flex flex-col items-center py-4" data-id="element-3805">
            <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-3806">
              <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-3807" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-3808">
              Berhasil Terkirim!
            </h3>
            <p className="text-sm text-gray-600 mb-6" data-id="element-3809">
              Bukti postingan {selectedPlatform} Anda telah diterima dan sedang
              dalam antrian validasi admin pusat.
            </p>
            <Button className="w-full" onClick={() => {
            setIsSuccessModalOpen(false);
            navigate('/officer/distribusi');
          }} data-id="element-3810">
              Kembali ke Daftar Tugas
            </Button>
          </div>
        </Modal>
      </div>
    </OfficerLayout>;
}